import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';
import { Button, HStack, Modal, theme, useResponsive } from '@sg/garnish';

export const ConfirmLocationLayoutFooter = ({
  isLoading,
  onContinue,
  onMoreLocations,
}: ConfirmLocationModalFooterProps) => {
  const { formatMessage } = useIntl();
  const { minWidth } = useResponsive();

  return (
    <Modal.Footer style={styles.footer} withoutTopBorder={minWidth.isSM}>
      <HStack itemsPerRow={onMoreLocations ? 2 : 1} gap={theme.spacing['4']}>
        {onMoreLocations ? (
          <Button
            size="large"
            palette="secondary"
            onPress={onMoreLocations}
            disabled={isLoading}
            testID="confirm-location.more-locations"
            accessibilityLabel={formatMessage(messages.locationMoreLocations)}
            accessibilityHint={formatMessage(messages.locationMoreLocations)}
          >
            {formatMessage(messages.locationMoreLocations)}
          </Button>
        ) : null}

        <Button
          size="large"
          onPress={onContinue}
          isLoading={isLoading}
          testID="confirm-location.continue"
          accessibilityLabel={formatMessage(messages.locationContinue)}
          accessibilityHint={formatMessage(messages.locationContinue)}
        >
          {formatMessage(messages.locationContinue)}
        </Button>
      </HStack>
    </Modal.Footer>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
  },
});

export type ConfirmLocationModalFooterProps = Readonly<{
  isLoading: boolean;
  onContinue: () => void;
  onMoreLocations?: () => void;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  locationMoreLocations: {
    defaultMessage: 'More locations',
    description: 'Location | More Locations',
  },
  locationContinue: {
    defaultMessage: 'Continue',
    description: 'Location | Continue',
  },
});
